export const verticalEllipsis = "⋮";
export const unicodeCrossMark = "✕";
